import { createContext, useContext } from 'react'

export const FoldoutContext = createContext<{
  onClose: (event: object, reason: 'backdropClick' | 'escapeKeyDown') => void
}>({ onClose: () => null })

export const useCloseHandler = () => useContext(FoldoutContext).onClose
